import React, { useState } from "react";
import PrimaryButton from "./inputs/PrimaryButton";
import { Api } from "../api/Api";
import '../styles/nonpatientdetails.css';
import { useAuth } from "../context/AuthContext";
import { parseJwt } from "../helpers/Helpers";
import { showToast } from "../helpers/UIHelper";
import demographic from '../assets/images/patient-demographic.png';

const NonPatientDetail = (props) => {
    const mobile = props.mobileNo.replaceAll('-', '').length === 12 
        ? props.mobileNo.replaceAll('-', '').substring(2) 
        : props.mobileNo;

    const [patientDetail, setPatientDetail] = useState({
        firstName: '',
        lastName: '',
        mobileNumber: mobile
    });
    const [buttonLoading, setButtonLoading] = useState(false);
    const [secondButtonLoading, setSecondButtonLoading] = useState(false);
    const Auth = useAuth();

    const removeSpecialChars = (str) => {
        return str.replace(/[^a-zA-Z0-9 ]/g, '').toUpperCase();
    };

    const loginNoPatient = () => {
        setButtonLoading(true);
        Api.authenticateNonPatient(patientDetail)
            .then((resp) => {
                if (resp.status === 200) {
                    const { accessToken } = resp.data;
                    const data = parseJwt(accessToken);
                    data.patients = resp.data.patients;
                    data.checknon = true;
                    const authenticatedUser = { data, accessToken };
                    Auth.userLogin(authenticatedUser);
                    
                    if (Auth.userIsFullAuthenticated()) {
                        window.location.href = "/";
                    }
                }
            })
            .catch((e) => {
                console.error('Authentication error:', e);
                showToast('error', 'An error occurred during authentication');
            })
            .finally(() => {
                setButtonLoading(false);
            });
    };

    const loginAgain = () => {
        setSecondButtonLoading(true);
        Auth.userLogout();
        setSecondButtonLoading(false);
    };

    return (
        <div className="non-patient-detail-container">
            <div className="top-image-container">
                <img src={demographic} alt="demographic"/>
            </div>
            <div className="text-container">
                <div className="main-text">Patient Details</div>
                <div className="sub-text">Please enter the details of the patient</div>
            </div>
            <div className="form-container">
                <div className="entry-field-container">
                    <div>First Name</div>
                    <input 
                        type="text"
                        name="firstName"
                        value={patientDetail.firstName}
                        onChange={(e)=>{setPatientDetail({...patientDetail,firstName:removeSpecialChars(e.target.value)})}}
                    />
                </div>
            </div>
            <div className="form-container">
                <div className="entry-field-container">
                    <div>Last Name</div>
                    <input 
                        type="text"
                        name="lastName"
                        value={patientDetail.lastName}
                        onChange={(e)=>{setPatientDetail({...patientDetail,lastName:removeSpecialChars(e.target.value)})}}
                    />
                </div>
            </div>
            <div className="form-container">
                <div className="entry-field-container">
                    <div>Contact Number</div>
                    <input 
                        type="tel"
                        name="mobileNumber"
                        maxLength="10"
                        inputMode="numeric"
                        value={patientDetail.mobileNumber}
                        onChange={(e)=>{setPatientDetail({...patientDetail,mobileNumber:removeSpecialChars(e.target.value)})}}
                    />
                </div>
            </div>
            <div className="form-container">
                <PrimaryButton 
                    isLoading={buttonLoading} 
                    label="Submit" 
                    onClick={loginNoPatient} 
                />
            </div>
            <div className="form-container">
                <PrimaryButton 
                    isLoading={secondButtonLoading} 
                    secondary={true} 
                    label="Use Another Number" 
                    onClick={loginAgain} 
                />
            </div>
        </div>
    );
};

export default NonPatientDetail;